import { Component, LOCALE_ID, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { GoogleAnalyticsEventsService } from '../../../services/google-analytics-events.service';
import { IcortexLocalizedPathService } from '../../../services/icortex-localized-path.service';
import { wfImage as wfImageFn } from '../wf-static';

/** Hero image file name per site language (default English fallback). */
const HERO_IMAGE_BY_LOCALE: Record<string, string> = {
    es: 'Home-Hero-1-1920x1080-ES-2026-06-04.png',
    pt: 'Home-Hero-1-1280X680-PT-2026-06-04.png'
};

const HERO_IMAGE_DEFAULT = 'Home-Hero-1-1280x680-2026-06-04.png';

@Component({
  standalone: true,
  selector: 'app-wf-hero',
  imports: [ RouterModule ],
  templateUrl: './wf-hero.component.html'
})
export class WfHeroComponent {

  readonly wfImage = wfImageFn;

  protected readonly signupHref = inject( IcortexLocalizedPathService ).getLocalizedPath( '/signup' );

  protected readonly heroImageSrc = this.resolveHeroImageSrc( inject( LOCALE_ID ) );

  private readonly googleAnalyticsEventsService = inject( GoogleAnalyticsEventsService );


  /**
   * @description Resolves the locale-aware hero image source URL.
   * @param localeId Active Angular locale identifier (e.g. es, pt, ko, en-US).
   * @return Absolute Webflow static image URL for the current language.
   */
  resolveHeroImageSrc( localeId: string ): string {

    const normalizedLocale = ( localeId || '' ).toLowerCase().split( '-' )[ 0 ];
    const imageName = HERO_IMAGE_BY_LOCALE[ normalizedLocale ] || HERO_IMAGE_DEFAULT;

    return wfImageFn( imageName );
  }

  sendGAEvent( category: string, action: string, label: string, value?: number ): void {

    this.googleAnalyticsEventsService.emitEvent( category, action, label, value );
  }

}
